<template>
  <div class="mt-3">
    <v-row dense>
      <v-col cols="12" sm="4">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="ARMAZEM"
          label="Depósito"
          required
          class="required rounded-tag-small"
          v-model="formData.armazem"/>
      </v-col>
      <v-col cols="12" sm="4">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="CONTA_CONTABIL"
          label="Conta contábil"
          required
          class="required rounded-tag-small"
          v-model="formData.contaContabil"/>
      </v-col>
      <v-col cols="12" sm="4">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="CONTA_FINANCEIRA"
          label="Conta financeira"
          required
          class="required rounded-tag-small"
          v-model="formData.contaFinanceira"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
